<template>
  <q-chip
    v-if="state"
    :color="state.color"
    :text-color="large ? undefined : 'white'"
    :outline="large"
    :icon="large || withoutIcon ? undefined : state.icon"
    :dense="!large"
    :size="large ? '16px' : undefined"
    :square="flat"
    class="chip text-center"
  >
    {{ state.label }}
    <q-tooltip v-if="signedAtLabel">
      {{ signedAtLabel }}
    </q-tooltip>
  </q-chip>
</template>

<script>
export default {
  props: {
    report: {
      type: Object,
      required: true
    },
    flat: {
      type: Boolean,
      default: false
    },
    // Full-size outlined chip for the report detail view, so it reads as a status and not a button;
    //  lists keep the dense solid one
    large: {
      type: Boolean,
      default: false
    },
    // Drop the leading icon (the detail view shows the label beside its own row icon)
    withoutIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // Prefer the explicit status (detail view); otherwise derive it from the row (list views)
    status () {
      if (this.report.signature_status) {
        return this.report.signature_status
      }
      if (this.report.signed_at) {
        return 'signed'
      }
      return this.report.signature_required ? 'awaiting' : null
    },
    state () {
      switch (this.status) {
        case 'signed': return { label: 'Signed', color: 'green-7', icon: undefined }
        // The dense chip has to fit the 95px status column of the lists
        case 'awaiting': return { label: this.large ? 'Awaiting Signature' : 'Awaiting', color: 'orange-8', icon: 'mdi-draw-pen' }
        default: return null
      }
    },
    signedAtLabel () {
      if (this.status === 'signed' && this.report.signed_at) {
        return `Signed on ${this.$formatSystemDate(this.report.signed_at, this.luxonFormats.FRIENDLY_DATE)}`
      }
      if (this.status === 'awaiting') {
        return 'Awaiting the client\'s signature'
      }
      return null
    }
  }
}
</script>

<style scoped lang="scss">
.chip {
  margin-left: 0;
  margin-right: 0;
  // Fills its container: StatusWithSignature sizes that container to the status
  // chip, so the two chips come out the same width
  width: 100%;

  :deep(.q-chip__content) {
    justify-content: center;
  }
}
</style>
